import React, { Component } from 'react'
import apiService from '../../services/ApiService'
import Select from 'react-select'

class EntityTypesCombo extends Component {
    constructor() {
        super()
        this.state = {
            entityTypesComboList: "",
        }
        this.isComponentStillMounted = true
    }

    componentDidMount() {
        this.getEntityTypesComboList()
    }

    componentWillUnmount() {
        this.isComponentStillMounted = false
    }

    getEntityTypesComboList = () => {
        apiService.getEntityTypesComboList()
            .then(listData => {
                if (listData && this.isComponentStillMounted) {
                     this.setState({
                        entityTypesComboList: listData.data
                    })
                    
                }
            })
            .catch(err => {
                console.error("Error data: ", err)
            })
    }

    render() {
        let list = {}

        
             list = Object.keys(this.state.entityTypesComboList).map((value,index) => {            
                    return {
                        label : this.state.entityTypesComboList[value],
                        value : this.state.entityTypesComboList[value]
                    }
            })
           

        
        list.sort((a,b) => a.label.localeCompare(b.label));


        return (
            <div>
                <Select
                value={this.props.selectedValue}
                placeholder="Select Type"
                options={list}
                onChange={(e) => { (e) ? this.props.entityTypesComboChange(e) : this.props.entityTypesComboChange([])}}
                />
            </div>
        )
    }
}
export default EntityTypesCombo


// WEBPACK FOOTER //
// ./src/common/DropDowns/EntityTypesCombo.js